// Blog writer (xobstaff Blogger agent) — backend/admin_api/views_blogger.py
import { apiFetch } from '@/lib/api'

export type BlogPostType = 'feature' | 'insight' | 'community'
export type ScheduleKind = 'interval' | 'daily' | 'weekly' | 'monthly'
export type BlogPostStatus = 'draft' | 'pending_review' | 'published' | 'archived'

export interface BloggerPost {
  id: number
  title: string
  slug: string
  post_type: BlogPostType
  status: BlogPostStatus
  focus_keyword: string
  seo_score: number | null
  word_count: number
  is_ai_generated: boolean
  created_at: string
  published_at: string | null
  /** A live feed post links to this article. */
  in_feed: boolean
}

export interface BloggerRun {
  id: string
  status: 'pending' | 'running' | 'success' | 'failed' | 'skipped' | 'killed'
  trigger_source: string
  created_at: string
  completed_at: string | null
  summary: string
}

export interface StaffAccount {
  id: number
  username: string
  name: string
}

export interface BloggerState {
  agent: {
    is_killed: boolean
    llm_model: string
    polling_interval_seconds: number
    last_run_at: string | null
    next_run_at: string | null
    schedule_kind: ScheduleKind
    /** 0 = Monday … 6 = Sunday */
    schedule_weekday: number
    schedule_day_of_month: number
    /** "HH:MM" */
    schedule_time: string
    schedule_timezone: string
  }
  settings: {
    enable_blog: boolean
    auto_publish_min_score: number
    posts_per_day: number
    share_to_feed: boolean
    feed_account: StaffAccount
    feed_account_is_default: boolean
  }
  staff_accounts: StaffAccount[]
  stats: {
    published: number
    pending_review: number
    drafts: number
    written_today: number
  }
  post_types: { key: BlogPostType; description: string }[]
  posts: BloggerPost[]
  runs: BloggerRun[]
}

export type BloggerUpdate = Partial<{
  is_killed: boolean
  llm_model: string
  polling_interval_seconds: number
  schedule_kind: ScheduleKind
  schedule_weekday: number
  schedule_day_of_month: number
  schedule_time: string
  schedule_timezone: string
  enable_blog: boolean
  auto_publish_min_score: number
  posts_per_day: number
  share_to_feed: boolean
  /** null = the XOBLACK Editorial system account */
  feed_account_id: number | null
}>

export const fetchBlogger = () =>
  apiFetch<BloggerState>('/api/admin/blogger/')

export const updateBlogger = (body: BloggerUpdate) =>
  apiFetch<BloggerState>('/api/admin/blogger/', { method: 'PATCH', body })

export const runBloggerNow = (body: { post_type?: string; topic?: string }) =>
  apiFetch<{ ok: boolean }>('/api/admin/blogger/run/', {
    method: 'POST',
    body
  })

export const blogPostAction = (
  id: number,
  action: 'publish' | 'unpublish' | 'archive' | 'share'
) =>
  apiFetch<BloggerState>(`/api/admin/blogger/posts/${id}/${action}/`, {
    method: 'POST'
  })
